import React from 'react'
import { Link } from 'react-router-dom'
import '../stylesheets/notfound.css'

function NotFound() {
  return (
    <>
      <section className="not_found">
        <div className='not_found__image'>
          <img src={require('../img/404.png')} alt="404" width={650} />
        </div>
        <div className="not_found__text">
          <h1>Ooops... </h1>
          <h3>No se encontró la página solicitada.</h3>
          <p>Regresa a la página principal: <Link className='not_found__link' to='/'>Inicio</Link></p>
          <p>Explora todas las secciones: <Link className='not_found__link' to='/mapa-del-sitio/'>Mapa del Sitio</Link></p>
          <p>Conoce nuestras herramientas de autodiagnóstico: <Link className='not_found__link' to='/diagnosticos/'>Diagnósticos</Link></p>
          <p>¿Necesitas ayuda? <Link className='not_found__link' to='/canales-de-atencion/'>Contáctanos</Link></p>
        </div>
      </section>
    </>
  )
}

export default NotFound